import { render, staticRenderFns } from "./SetUpEditCast.vue?vue&type=template&id=2d10c1d1&scoped=true&"
import script from "./SetUpEditCast.vue?vue&type=script&lang=js&"
export * from "./SetUpEditCast.vue?vue&type=script&lang=js&"
import style0 from "./SetUpEditCast.vue?vue&type=style&index=0&id=2d10c1d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d10c1d1",
  null
  
)

export default component.exports